import { JulianDate, ScreenSpaceEventHandler, ScreenSpaceEventType } from "cesium";

export function setupClickHandler(viewer, callback, showToast, toastType = "warning") {
  // Create handler bound to the canvas
  const handler = new ScreenSpaceEventHandler(viewer.scene.canvas);

  // Register LEFT_CLICK input action
  handler.setInputAction((click) => {
    // Pick the object under the cursor
    const pickedObject = viewer.scene.pick(click.position);

    // If nothing picked or no .id (not an Entity), do nothing
    if (!pickedObject || !pickedObject.id) return;

    // Extract the Entity
    const entity = pickedObject.id;

    // Try to find the owning dataSource safely (covering both public/private fields)
    const entityCollection = entity.entityCollection || entity._entityCollection || null;
    const dataSource = (entityCollection && (entityCollection.owner || entityCollection._owner)) || null;

    // Safely read layerName and normalize to lowercase string
    const layerName = String(dataSource?.layerName ?? "").toLowerCase();

    // Guard: if layerName does not include "lanelet" -> show toast & exit
    if (!layerName.includes("lanelet")) {
      if (typeof showToast === "function") {
        showToast("Select Lanelet", toastType);
      }
      return;
    }

    // We are on a lanelet layer; extract properties.id
    const idProp = entity.properties?.id;

    // If there's no id in properties, inform and exit
    if (idProp == null) {
      if (typeof showToast === "function") {
        showToast("Selected entity has no 'properties.id'", toastType);
      }
      return;
    }

    // Compute current time for Cesium properties if needed
    const now = viewer?.clock?.currentTime ?? (JulianDate && JulianDate.now ? JulianDate.now() : undefined);

    // Support both raw values and Cesium Property with getValue()
    const idValue = typeof idProp.getValue === "function" ? idProp.getValue(now) : idProp;

    // Call the user callback with the resolved id value
    try {
      callback(idValue);
    } catch (e) {
      // Optional: surface callback errors for easier debugging
      // eslint-disable-next-line no-console
      console.error("callback error:", e);
    }
  }, ScreenSpaceEventType.LEFT_CLICK);

  return handler;
}
